import React, { Component } from "react";
import deburr from "lodash/deburr";
import Autosuggest from "react-autosuggest";
// import match from "autosuggest-highlight/match";
import match from "./match";
import parse from "autosuggest-highlight/parse";
import SearchIcon from "@material-ui/icons/Search";
import TextField from "@material-ui/core/TextField";
import Paper from "@material-ui/core/Paper";
import MenuItem from "@material-ui/core/MenuItem";
import { withStyles } from "@material-ui/core/styles";
import InputAdornment from "@material-ui/core/InputAdornment";
import ListItemIcon from "@material-ui/core/ListItemIcon";

const styles = theme => ({
  root: {
    height: 50,
    flexGrow: 1,
    marginBottom: 7,
  },
  container: {
    position: "relative",
  },
  input: {
    height: 47,
    fontSize: 16,
  },
  inputBorder: {    
    border: '1px solid #e4e4e4',
    borderRadius: 4,
  },
  suggestionsContainerOpen: {
    position: "absolute",
    zIndex: 1,
    // marginTop: theme.spacing(1),
    marginTop: 8,
    left: 0,
    right: 0
  },
  suggestion: {
    display: "block",
    borderBottom: "1px solid #ededed",
    borderRadius: 3
  },
  suggestionsList: {
    margin: 0,
    padding: 0,
    listStyleType: "none"
  },
});

class IntegrationAutosuggestClass extends Component {
  constructor(props) {
    super(props);
    this.state = {
      single: "",
      anchorEl: null,
      suggestions: [],
      stateSuggestions: [],
      data: props.data
    };
  }

  componentDidMount() {
  }

  handleSuggestionsFetchRequested = ({ value, reason }) => {
    const { reportPeriod } = this.props;
    if (reason != 'input-changed') return;

    
    const searchterms = value.trim().toLowerCase();

    if (searchterms.length <3) return;

    const query = encodeURIComponent(deburr(searchterms));
    fetch(`/api/summary-report-tree-search?query=${query}&period=${reportPeriod}`)
    .then(res => res.json())
    .then(data => {
      this.setState(
        {
          stateSuggestions: data
        }
      );

    })

  };

  handleSuggestionsClearRequested = () => {
    this.setState({ stateSuggestions: [] });
  };

  handleKeyDown = (event) => {
    const { keyCode } = event;

    if (keyCode === 13) {
      if (this.state.single) {
        const actualValue = this.state.stateSuggestions.filter(x => x.label === this.state.single)[0];

        if (actualValue)
          window.location = `/summary-reports/${actualValue.id}`;
      }
    }

  };

  handleChange = (event, { newValue, method }) => {
    const actualValue = this.state.stateSuggestions
    .filter(x => x.id === newValue)[0];

    if (method==='click' || method==='enter') {
      this.setState({
        single: actualValue.label,
        value: actualValue
      })
  
      window.location = `/summary-reports/${actualValue.id}`;

    } else {
      this.setState({
        single: newValue,
        value: actualValue
      })
  
    }

  };

  getSuggestionValue(suggestion) {
    return suggestion.id;
  }

  renderInputComponent(inputProps) {
    const { classes, inputRef = () => {}, ref, ...other } = inputProps;

    return (
      <TextField 
        autoFocus
        fullWidth
        variant="outlined"
        InputProps={{
          inputRef: node => {
            ref(node);
            inputRef(node);
          },
          classes: {
            root: classes.input,
            notchedOutline: classes.inputBorder,
          },
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon style={{ color: "#d6d6d6" }} />
            </InputAdornment>
          )
        }}
        {...other}
      />
    );
  }

  renderSuggestion(suggestion, { query, isHighlighted }) {
    const matches = match(suggestion.label, query); // for ("Albert", "a"), RETURNS [0,1]
    const parts = parse(suggestion.label, matches); // for ("Albert", [[0, 1]]), RETURNS [{text: "A", highlight: true}, {text: "lbert", highlight: false}]

    return (
      <MenuItem selected={isHighlighted} component="div">
        <ListItemIcon>
          <SearchIcon style={{ color: "lightgray" }} />
        </ListItemIcon>
        <div>
          {/* <a href={`/summary-reports/${suggestion.id}`} target="_blank"> */}
          {parts.map((part, i) => (
            <span key={i} style={{ fontWeight: part.highlight ? 700 : 400 }}>
              {part.text}
            </span>
          ))}
          {/* </a> */}
        </div>
      </MenuItem>
    );
  }

  render() {
    const autosuggestProps = {
      suggestions: this.state.stateSuggestions,
      onSuggestionsFetchRequested: this.handleSuggestionsFetchRequested,
      onSuggestionsClearRequested: this.handleSuggestionsClearRequested,
      getSuggestionValue: this.getSuggestionValue,
      renderInputComponent: this.renderInputComponent,
      renderSuggestion: this.renderSuggestion
    };

    const { classes } = this.props;

    return (
      <div className={classes.root}>
        <Autosuggest
          {...autosuggestProps}
          inputProps={{
            classes,
            id: "react-autosuggest-simple",
            placeholder: "Search",
            value: this.state.single,
            onChange: this.handleChange,
            onKeyDown: this.handleKeyDown
          }}
          theme={{
            container: classes.container,
            suggestionsContainerOpen: classes.suggestionsContainerOpen,
            suggestionsList: classes.suggestionsList,
            suggestion: classes.suggestion
          }}
          renderSuggestionsContainer={options => (
            <Paper {...options.containerProps} square>
              {options.children}
            </Paper>
          )}
        />
      </div>
    );
  }
}

export default withStyles(styles)(IntegrationAutosuggestClass);



// WEBPACK FOOTER //
// ./src/components/SRHHeaders/SummaryReportHeader/components/SwitchReport/IntegrationAutosuggestClass.js